import type { FaireProductEntity } from "../../entity_types/product";

export const p_g78qtn23pp: FaireProductEntity = {
  token: "p_g78qtn23pp",
  type: "product",
  name: "HOLY SMOKE SCENTED CANDLE",
  brandToken: "b_s4mtr37bpt",
  brandName: "Hazeltine Scent Company",
  imageUrl:
    "https://cdn.faire.com/fastly/64d20cc836b4bb08a761606f7d944ee7a15a60bbe7ac739abdd9f8ebc10d4d8c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/49d36644f5743ee0d848220aa42cfad8fffb8e397d64d264f7f7077a2d8787ae.png",
    "https://cdn.faire.com/fastly/def75ac89f52aa56bcfcaf2de9cd7b332e60bdae7c6a6789ad0da446f9611f44.jpeg",
  ],
  priceDollars: 27,
  description:
    "Holy Smoke is a nod to all of our most pious earthly rituals, with notes of smoldering incense smoke, ancient resins, wooden pews, and sun-dried dates. Inspired by altars, effigies and the sacred offerings people have always made in our search for atonement and absolution. Light this candle anytime for a moment of holy ritual. \n\nTop notes: incense smoke, dates\nHeart notes: copal resin, oakwood\nBase notes: frankincense \n\n * 9 ounces / 255 grams \n * approximately 40 hours of burn time \n * coconut wax ",
  tags: [],
  msrpDollars: 54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:47.875Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
